/* global require */
window._ = require("lodash");
import axios from "axios";
import Store from "./store/index";

const API_PATH = "api",
    BASE_URL = `${window.location.protocol}//${window.location.host}/${API_PATH}`;

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
    (success) => {
        Store.dispatch("overlay/turnOff");
        return success;
    },
    (error) => {
        Store.dispatch("overlay/turnOff");
        Store.dispatch("errors/catch", error);
        return Promise.reject(error);
    }
);
axios.interceptors.request.use((config) => {
    config.url = BASE_URL + config.url;
    Store.dispatch("validation/reset");
    Store.dispatch("overlay/turnOn");
    return config;
});

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
